import React from 'react';
import firebase from 'utils/firebase';

import './userBar.scss';

const getUserEmail = () => firebase.auth().currentUser.email;
const onLogout = async () => {
  try {
    await firebase.auth().signOut();
  } catch (error) {
    console.error(error);
  }
};

const UserBar = () => (
  <div className="user-bar">
    <div className="user-email">{getUserEmail()}</div>
    <button type="button" className="logout" onClick={onLogout}>
      Logout
    </button>
  </div>
);

export default UserBar;
